import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/machine-learning-company/solutions/ml-solutions-bg.webp";

function Nfttechstack() {
  return (
    <section
      className="nft_tech_stack machine_stack p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#fff" }}>
              Leading AI Models Powering Our Solutions
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={11}
            className="m-auto text-center"
          >
            <div className="nft_tech_main">
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/gpt_logo.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>GPT-4</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/llama.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>LLaMA-3</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/palm.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>PaLM-2</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/claude.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Claude</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/dall_e.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>DALL-E 2</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/whisper.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Whisper</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/stable.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Stable Diffusion</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/micros.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Microsoft Phi-2</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/gemini.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Google Gemini</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div
                  className="nft_tech_img"
                  style={{ background: "none", border: "none" }}
                >
                  <StaticImage
                    src="../../images/services-usa/machine-learning-company/sol-svg/vicuna.svg"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Vicuna</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nfttechstack;
